import {Injectable} from '@angular/core';
import {Rest} from '../../../common/server-actions/rest';
import {RequestOptions} from 'ac-infra';

@Injectable({providedIn: 'root'})
export class ServerConfigurationRestService extends Rest {


    constructor() {
        super({url: 'settings/server/general'});
    }

    public getServerConfiguration = (success = (...args) => null, failure = () => null) => {
        const onSuccess = (value) => {
            success(this.extractObject(value));
        };
        const promise = this.get({skipPopulateFilter: true, build204JSON: false});
        promise.then(onSuccess).catch(failure);
        return promise;
    };

    public getMeteringConfiguration(): Promise<any> {
        return this.get({url: 'settings/metering', skipPopulateFilter: true, build204JSON: false}).then((value) => {
            return this.extractObject(value).data;
        });
    }

    public getServerLogLevels = ({success, failure = () => null, ...requestOptions}: RequestOptions) => {
        const onSuccess = (value) => {
            success(this.extractObject(value));
        };
        this.get({...requestOptions, url: 'settings/logLevels', skipPopulateFilter: true, build204JSON: false, extendParameters: true}).then(onSuccess).catch(failure);
    };

    public editServerLogLevels = (success, failure,serverConfiguration) => {
        this.put(success, failure, serverConfiguration, 'settings/logLevels');
    };

    public editServerConfiguration = (serverConfiguration) => {
        const successMsg = 'Server configuration updated successfully';
        const onSuccess = (response) => {
            this.successfulUpdateAction(response.data.description || successMsg);
        };

        this.put(onSuccess, () => {
        }, serverConfiguration);
    };

    public editMeteringConfiguration = (meteringConfiguration, success) => {
        const successMsg = 'Metering configuration updated successfully';
        const onSuccess = (response) => {
            this.successfulUpdateAction(response.data.description || successMsg);
            success();
        };

        this.put(onSuccess, () => {}, meteringConfiguration, 'settings/metering');
    };

    public sendReportNow = (success) => {
        const successMsg = 'Metering was sent successfully';
        const onSuccess = (response) => {
            this.successfulUpdateAction(response.data.description || successMsg);
            success();
        };

        this.add(onSuccess, () => {}, undefined, 'settings/actions/sendMetering');
    };


    successfulUpdateAction = (message) => {
        this.acDialogService.info(message);
    };
}
